import { EmployeesGuard } from './employees.guard';
import { OfficesGuard } from './offices.guard';
import { PositionsGuard } from './positions.guard';

export * from './employees.guard';
export * from './positions.guard';
export * from './offices.guard';

export const guards = [EmployeesGuard, PositionsGuard, OfficesGuard];
